/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Oto_B1_DescInputs */

const en_simple_oto_b1_desc = /** @type {(inputs: Simple_Oto_B1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A few sentences about your business, then three short questions. You get a short plan of steps written in everyday language.`)
};

const id_simple_oto_b1_desc = /** @type {(inputs: Simple_Oto_B1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beberapa kalimat tentang usahamu, lalu tiga pertanyaan singkat. Hasilnya rencana ringkas berisi langkah-langkah berbahasa sehari-hari.`)
};

/**
* | output |
* | --- |
* | "A few sentences about your business, then three short questions. You get a short plan of steps written in everyday language." |
*
* @param {Simple_Oto_B1_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_oto_b1_desc = /** @type {((inputs?: Simple_Oto_B1_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Oto_B1_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_oto_b1_desc(inputs)
	return en_simple_oto_b1_desc(inputs)
});